<template>
  <Modal
    :open="show"
    @closed="$emit('close')"
  >
    <div class="modal-header border-0">
      <h5 class="modal-title m-0 d-flex align-items-center">
        Approve Leave Request
      </h5>
      <button @click="$emit('close')" type="button" class="btn-close outline-none" data-dismiss="modal" aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label for="approval_comments" class="form-label">Comments (Optional)</label>
          <textarea 
            class="form-control" 
            id="approval_comments" 
            v-model="comments" 
            rows="3"
            :disabled="loading"
          ></textarea>
        </div>
        <div class="d-flex justify-content-end">
          <button 
            type="button" 
            class="btn btn-outline-secondary me-2" 
            @click="$emit('close')"
            :disabled="loading"
          >
            Cancel
          </button>
          <button 
            type="submit" 
            class="btn btn-success" 
            :disabled="loading"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Approve
          </button>
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'ApproveLeaveRequestModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'approve'],
  setup(props, { emit }) {
    const comments = ref('');

    const handleSubmit = () => {
      emit('approve', comments.value.trim());
      comments.value = '';
    };

    return {
      comments,
      handleSubmit
    };
  }
};
</script>
